import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit,ChangeDetectorRef,AfterContentChecked } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { GlobalService } from 'src/app/service/global.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { NotificationService } from 'src/app/service/notification.service';
import { ApprovalFlowService } from '../approval-flow-models/approval-flow.service';
import { WorkflowApproval  } from '../approval-flow-models/workflow-approval.model';

@Component({
  selector: 'app-manage-approval',
  templateUrl: './manage-approval.component.html',
  styleUrls: ['./manage-approval.component.css']
})
export class ManageApprovalComponent implements OnInit {
  ordersTableColumns: TableColumn[];
  ordersTableColumns2: TableColumn[];
  actions: any;
  actionButtons: any;
  columnsData: any;
  showLoading : boolean;
  approvalTypes : string []= [];
  timeOutActions : string []= [];
  approvalCriterias: string []= [];
  approvalValueSet: string []= [];
  suppervisorSet= new Set<string>();
  levels:number[]= [];
  stages:number[]= [];
  buttons: Buttons[];
  workflowApprovals:WorkflowApproval[] =[];
  workflowApproval = new WorkflowApproval();
  allWorkflowApprovals:WorkflowApproval[] =[];
  workflowApprovalsByAprvlId:WorkflowApproval[] =[];
  employeeId : string ='';
  updateWorkFlow = new WorkflowApproval();
  userData: AddUser[];
  control = new FormControl();
  filteredUsers: Observable<AddUser[]> | undefined;
  filteredValues: AddUser[];
  empId: string;
  isAccessDisabled: boolean = false;
  constructor( private httpService: HttpClient,private approvalFlowService: ApprovalFlowService,
    private manageUserService:ManageUserService,private authgurdService: AuthGaurdService,
    private notificationService:NotificationService,private router: Router,
    private changeDetector:ChangeDetectorRef,private globalService: GlobalService) { }

  ngOnInit(): void {
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('approval-flow');
    if(this.isAccessDisabled)
    this.notificationService.notify (NotificationType.WARNING,"Edit Permission Has Disabled Please Contact To Adminstrator");
  }

  init(){
    this.initializeColumns();
    this.workflowApproval.created_dt =new  Date();
    this.getAllApprovals();
  }

  // ngAfterContentChecked() : void {
  //   this.changeDetector.detectChanges();
  //   console.log(this.workflowApprovals);
  //   const i = this.workflowApprovals.length;
  //   if(this.workflowApprovals[i-1].employee_id){
  //      this.empId = this.workflowApprovals[i-1].employee_id
  //   }
  //   }

  getAllApprovals(){
    this.approvalFlowService.getAllApprovalWorkFlows()
    .subscribe((data: WorkflowApproval[]) => {
      this.allWorkflowApprovals = data;
      //this.getAllUserData();
    });
  }

  getAllUserData() {
    this.manageUserService.getPendingUsers()
      .subscribe((data: AddUser[]) => {
        this.userData = data;
        for (let user of this.userData) {
            let approvalVal = user.first_name + ' '+user.last_name+ '_' + user.employeeId
            if (user.user_type)
              approvalVal = approvalVal + '_' + user.user_type
            user.first_name = approvalVal;
        }
        this.filterUsers();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  filterUsers() {
    this.filteredUsers = this.control.valueChanges.pipe(
      startWith(''),
      map(value => value.length >= 3 ? this._filter(value):[])
    );
  }

  private _filter(value: string): AddUser[] {
    const filterValue = this._normalizeValue(value);
    this.filteredValues = this.userData.filter(user => this._normalizeValue(user.first_name).includes(filterValue));

    return this.userData.filter(user => this._normalizeValue(user.first_name).includes(filterValue));
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }


  rowAction(row: any) {
    console.log(" row ....", row, "=== val  ", row.value);
    this.findApprovalWorkflowByAprvId(row);
     }

   findApprovalWorkflowByAprvId(row: any){
    this.approvalFlowService.fetchWorkflowByAprvlId(row.row.approvalId)
    .subscribe((data: WorkflowApproval[]) => {
       this.workflowApprovalsByAprvlId = data;
       if (row.value === 'Update' && !this.isAccessDisabled) {
         this.workflowApprovals =[]
         this.workflowApprovals = data;
         this.workflowApproval.name = row.row.name;
         this.workflowApproval.description = row.row.description;
         this.updateWorkFlow.name =row.row.name;
         this.updateWorkFlow.description = row.row.description;
         this.updateWorkFlow.approvalId = this.workflowApprovalsByAprvlId[0].approvalId;
         document.getElementById('update Approval').click();
      }
      else if(row.value === 'Delete' && !this.isAccessDisabled){
        this.deleteApprovalsByApprovalId(row.row.approvalId);
      } 
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }
 
  public deleteApprovalsByApprovalId(approvalId: string): void {
    if (confirm("Are you sure to delete this Record")) {
        this.approvalFlowService.deleteApprovalsByApprovalId(approvalId).subscribe(
          (response: CustomHttpRespone) => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
            this.init();
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
    }
  }

  innerRowAction(row: any) {
    if (row.value === 'Delete' && !this.isAccessDisabled)
   this.deleteApprovalById(row.row.id);
  }

  public deleteApprovalById(id: number): void {
    if (confirm("Are you sure to delete this Record")) {
        this.approvalFlowService.deleteApprovalById(id).subscribe(
          (response: CustomHttpRespone) => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
            this.init();
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        )
    }
  }

  actionOnButton(action: any) {
    this.workflowApproval.created_by =  localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.workflowApprovals.push(this.workflowApproval);
    if(!this.isAccessDisabled)
    document.getElementById(action).click();
  }

  
  exportExcel(){

  }

  public customSort = (event) => {
    console.log(event);
  }

  submitApproval(approvalForm: NgForm){
    console.log(this.workflowApprovals);
    this.approvalFlowService.addApprovalWorkFlows(this.workflowApprovals).subscribe
      (response => {
        response = response as ErrorResponseMessage;
        this.notificationService.notify(NotificationType.SUCCESS, `Added successfully`);
        approvalForm.reset();
        this.clickButton('new-workflow-close');
        this.showLoading = false;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      })
    
  }

  updateApproval(approvalForm: NgForm){
    if(  this.updateWorkFlow.name!=this.workflowApproval.name ||   
      this.updateWorkFlow.description !=this.workflowApproval.name  ){
        for(let approval of this.workflowApprovals){
          approval.name = this.workflowApproval.name;
          approval.description = this.workflowApproval.description;
        }
      }
      console.log(this.workflowApprovals);
    this.approvalFlowService.updateApprovalWorkFlows(this.workflowApprovals).subscribe
      (response => {
        response = response as ErrorResponseMessage;
        this.notificationService.notify(NotificationType.SUCCESS, `Updated successfully`);
        approvalForm.reset();
        this.clickButton('new-workflow-close');
        this.showLoading = false;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      }) 
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
    window.location.reload();
  }

  addApprovals(){
    this.changeDetector.detectChanges();
    let i=this.workflowApprovals.length;
    console.log(this.workflowApprovals, this.empId);
    const workflowAprvl = new WorkflowApproval();
    workflowAprvl.name = this.workflowApproval.name;
    workflowAprvl.description = this.workflowApproval.description;
    workflowAprvl.created_dt =new  Date();
    workflowAprvl.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    workflowAprvl.approvalId = this.updateWorkFlow.approvalId;
    this.workflowApprovals.push(workflowAprvl);
    this.workflowApprovals[i-1].employee_id =  this.empId;
    console.log(this.workflowApprovals);
  }

  onChangeVal(user:AddUser){
    let i=this.workflowApprovals.length;
    console.log(user);
    this.workflowApprovals[i].employee_id = user.employeeId;
  }
  
  close(workFlowForm: NgForm){
    workFlowForm.reset();
    this.workflowApprovals =[];
    this.init();
  }
  
  check(id:number):boolean{
    if(id === 0)
      return true;
      else
      return false;
  }
  

  redirect(url : string){
    this.router.navigate(['/' + url]);
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns2 = this.columnsData.EmployeeList;
        this.ordersTableColumns = this.columnsData.WorkFlowApproval;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    this.buttons = [

      {
        name: 'Back',
        pagenavigation: 'approval-flow'
      }
    ],

   this.actions = [      
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }
    ],
    this.actionButtons = [
      
      {
        name: 'Add Approval',
        class: 'btn btn-default btn-xs'
      }
    ]
   
  }
   
}
